"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../../webpack/constants");
const imagesUrl = (path) => `${constants_1.IMAGES[1]}${path}`;
exports.default = imagesUrl;
